/*
 * FAQ overview
 *
 * Builds a single navigation list from every Accordions section that has
 * "Show in overview" ticked. Sections cannot read each other's settings in
 * Liquid, so each flagged section only marks itself with
 * data-faq-overview-title and this script collects them.
 *
 * Desktop: floats to the left of the (centred, narrow) FAQ column.
 * Mobile:  a horizontal scrollable pill bar, with edge fades and arrows.
 */
(function () {
  if (window.__mmtFaqOverview) return;
  window.__mmtFaqOverview = true;

  var SECTION_SELECTOR = '[data-faq-overview-title]';
  var NAV_ID = 'FaqOverview';

  function headerOffset() {
    var header = document.querySelector('[data-section-type="header"], .header');
    var height = header ? header.getBoundingClientRect().height : 0;
    return height + 20;
  }

  function build() {
    var existing = document.getElementById(NAV_ID);
    if (existing) existing.remove();

    var sections = Array.prototype.slice.call(document.querySelectorAll(SECTION_SELECTOR));
    if (!sections.length) return;

    var nav = document.createElement('nav');
    nav.id = NAV_ID;
    nav.className = 'faq-overview';
    nav.setAttribute('aria-label', document.documentElement.lang === 'nl' ? 'Overzicht' : 'Overview');

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'faq-overview__arrow faq-overview__arrow--prev';
    prev.setAttribute('aria-label', 'Scroll left');
    prev.innerHTML = '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="M7 1 1 7l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var next = prev.cloneNode(true);
    next.className = 'faq-overview__arrow faq-overview__arrow--next';
    next.setAttribute('aria-label', 'Scroll right');
    next.innerHTML = '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="m1 1 6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var list = document.createElement('div');
    list.className = 'faq-overview__list';

    var items = [];
    sections.forEach(function (section) {
      var label = (section.getAttribute('data-faq-overview-title') || '').trim();
      if (!label) return;
      if (!section.id) section.id = 'FaqSection--' + Math.random().toString(36).slice(2, 9);

      var item = document.createElement('a');
      item.className = 'faq-overview__item';
      item.href = '#' + section.id;
      item.textContent = label;
      item.addEventListener('click', function (event) {
        event.preventDefault();
        var top = section.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      });

      list.appendChild(item);
      items.push({ item: item, section: section });
    });

    if (!items.length) return;

    nav.appendChild(prev);
    nav.appendChild(list);
    nav.appendChild(next);
    sections[0].parentNode.insertBefore(nav, sections[0]);

    // Arrows scroll the pill bar; edge fades follow the scroll position
    prev.addEventListener('click', function () {
      list.scrollBy({ left: -list.clientWidth * 0.7, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      list.scrollBy({ left: list.clientWidth * 0.7, behavior: 'smooth' });
    });

    function updateOverflow() {
      var max = list.scrollWidth - list.clientWidth;
      var overflowing = max > 1;
      nav.classList.toggle('has-overflow-left', overflowing && list.scrollLeft > 1);
      nav.classList.toggle('has-overflow-right', overflowing && list.scrollLeft < max - 1);
    }

    // Desktop only: start level with the first FAQ section so the menu never
    // overlaps the hero, then pin it below the header once scrolled past.
    function positionNav() {
      if (!window.matchMedia('(min-width: 1400px)').matches) {
        nav.style.top = '';
        return;
      }
      var minTop = headerOffset() + 20;
      var offset = parseInt(getComputedStyle(nav).getPropertyValue('--faq-overview-top-offset'), 10);
      if (isNaN(offset)) offset = 200;
      var firstTop = items[0].section.getBoundingClientRect().top;
      nav.style.top = Math.max(minTop, firstTop + offset) + 'px';
    }

    function updateActive() {
      var marker = headerOffset() + 40;
      var activeIndex = 0;
      items.forEach(function (entry, index) {
        if (entry.section.getBoundingClientRect().top <= marker) activeIndex = index;
      });
      items.forEach(function (entry, index) {
        entry.item.classList.toggle('is-active', index === activeIndex);
      });
    }

    function onScroll() {
      updateActive();
      positionNav();
    }

    list.addEventListener('scroll', updateOverflow, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      updateOverflow();
      positionNav();
    });

    updateOverflow();
    updateActive();
    positionNav();
    // images above the FAQs can change the offset once they load
    window.addEventListener('load', positionNav);
    setTimeout(function () {
      updateOverflow();
      positionNav();
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  // Keep the overview in sync while editing in the theme editor
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(build, 50);
    });
  });
})();
